var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-1,.cls-2,.cls-3{fill:none;}.cls-2{stroke:#e8ba3a;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-4{clip-path:url(#clippath);}.cls-3{stroke:#193c34;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.81,
    y: 1.71,
    width: 236.39,
    height: 146.58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 202.45,
    cy: 123.49,
    r: 16.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 202.45,
    cy: 123.49,
    r: 5.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 117.34,
    cy: 123.49,
    r: 16.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 117.34,
    cy: 123.49,
    r: 5.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 186.43,
    y1: 121.11,
    x2: 133.36,
    y2: 121.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m91.16,42.92h79.25c1.42,0,2.56,1.15,2.56,2.56v75.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m100.52,122.23h-14.3c-1.42,0-2.56-1.15-2.56-2.56v-47.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m172.97,59.22h28.55c2.04,0,3.92,1.12,4.88,2.92l17.59,32.87c.44.83.67,1.75.67,2.69v16.96c0,1.71-.75,3.33-2.06,4.43l-3.7,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.66,94.86h8.92c1.42,0,2.56,1.15,2.56,2.56v9.08c0,1.42-1.15,2.56-2.56,2.56h-8.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m211.11,70.94h-21.18c-1.93,0-3.5,1.57-3.5,3.5v18.21c0,1.93,1.57,3.5,3.5,3.5h34.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.08,
    y1: 57.62,
    x2: 162.44,
    y2: 57.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.08,
    y1: 66.51,
    x2: 162.44,
    y2: 66.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.04,
    y1: 139.5,
    x2: 234.58,
    y2: 139.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 70.48,
    cy: 53.35,
    r: 23.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "62.49 54.06 66.72 59.39 78.46 47.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m13.31,112.84h0c.77,0,1.46-.45,1.77-1.16,1.04-2.41,3.44-4.1,6.23-4.1h32.44c2.79,0,5.19,1.69,6.23,4.1.3.7,1,1.16,1.77,1.16h0c.79,0,1.48.58,1.57,1.36.1.92-.62,1.71-1.52,1.71h-.04c-.77,0-1.46.45-1.77,1.16-1.04,2.41-3.44,4.1-6.23,4.1H21.32c-2.79,0-5.19-1.69-6.23-4.1-.3-.7-1-1.16-1.77-1.16h-.04c-.87,0-1.57-.73-1.53-1.61.04-.83.75-1.46,1.58-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m13.31,99.26h0c.77,0,1.46-.45,1.77-1.16,1.04-2.41,3.44-4.1,6.23-4.1h32.44c2.79,0,5.19,1.69,6.23,4.1.3.7,1,1.16,1.77,1.16h0c.79,0,1.48.58,1.57,1.36.1.92-.62,1.71-1.52,1.71h-.04c-.77,0-1.46.45-1.77,1.16-1.04,2.41-3.44,4.1-6.23,4.1H21.32c-2.79,0-5.19-1.69-6.23-4.1-.3-.7-1-1.16-1.77-1.16h-.04c-.87,0-1.57-.73-1.53-1.61.04-.83.75-1.46,1.58-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m61.81,88.74h-.04c-.77,0-1.46.45-1.77,1.15-1.04,2.41-3.44,4.1-6.23,4.1H21.32c-2.79,0-5.19-1.69-6.23-4.1-.3-.7-1-1.15-1.77-1.15h-.04c-.87,0-1.57-.73-1.53-1.61.04-.83.75-1.46,1.58-1.46.77,0,1.46-.45,1.77-1.15,1.04-2.41,3.44-4.1,6.23-4.1h32.44c2.79,0,5.19,1.69,6.23,4.1.3.7,1,1.15,1.77,1.15.39,0,.77.14,1.05.39.28.24.48.58.52.98.1.92-.62,1.71-1.53,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.76,121.16H21.32c-2.79,0-5.19-1.69-6.23-4.1-.3-.7-1-1.16-1.77-1.16h-.04c-.87,0-1.57-.73-1.53-1.61.04-.83.75-1.46,1.58-1.46.77,0,1.46-.45,1.77-1.15,1.04-2.41,3.44-4.1,6.23-4.1h16.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.34,94h-17.02c-2.79,0-5.19,1.69-6.23,4.1-.3.7-1,1.15-1.77,1.15-.83,0-1.54.63-1.58,1.46-.04.88.66,1.61,1.53,1.61h.04c.77,0,1.46.45,1.77,1.15,1.04,2.41,3.44,4.1,6.23,4.1h16.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.02,80.82c.72-.26,1.49-.4,2.3-.4h14.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.7,83.39c-.24.35-.45.73-.62,1.13-.3.7-1,1.15-1.77,1.15-.83,0-1.54.63-1.58,1.46-.04.88.66,1.61,1.53,1.61h.04c.77,0,1.46.45,1.77,1.15,1.04,2.41,3.44,4.1,6.23,4.1h17.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m63.63,129.89H11.44c-.88,0-1.6-.71-1.6-1.6v-3.18c0-.88.71-1.6,1.6-1.6h52.19c.88,0,1.6.71,1.6,1.6v3.18c0,.88-.71,1.6-1.6,1.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.84,
    y: 129.89,
    width: 8.67,
    height: 8.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 50.06,
    y: 129.89,
    width: 8.67,
    height: 8.86
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01);
export default __webpack_public_path__ + "static/media/logo01.46b9bf416ee6fd4f36b7ad40c798283e.svg";
export { ForwardRef as ReactComponent };